import { render } from "./ProductTile.vue?vue&type=template&id=26b6aa1a&scoped=true"
import script from "./ProductTile.vue?vue&type=script&lang=js"
export * from "./ProductTile.vue?vue&type=script&lang=js"

import "./ProductTile.vue?vue&type=style&index=0&id=26b6aa1a&scoped=true&lang=css"

import exportComponent from "/var/www/42/uchowanca/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b6aa1a"]])

export default __exports__